export default __webpack_public_path__ + "static/media/22.9201bf2c.png";